<script>
export default {
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    }
  }
};
</script>
